export default "__VITE_ASSET__Cf4lI9GO__"